import {AfterViewInit, Component, forwardRef, Input, ViewChild, OnInit} from '@angular/core';
import {InfoModalPage} from "../../pages/info-modal/info-modal";
import {AlertController, ModalController, Select} from "ionic-angular";
import {ControlValueAccessor, DefaultValueAccessor, FormGroup, NG_VALUE_ACCESSOR} from "@angular/forms";
import {ReplaySubject} from "rxjs";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'item-select-other',
  templateUrl: 'item-select-other.html',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => ItemSelectOtherComponent),
    multi: true
  }]
})
export class ItemSelectOtherComponent implements ControlValueAccessor, AfterViewInit, OnInit {

  @Input()
  label: string = '';

  @Input()
  form: FormGroup;

  @Input()
  formControlName: string = '';

  @Input()
  options = []

  @Input()
  infoTitle = '';

  @Input()
  infoText = '';

  @Input()
  required = false;

  @ViewChild(DefaultValueAccessor) valueAccessor: DefaultValueAccessor;
  @ViewChild('select') select: Select;

  delegatedMethodCalls = new ReplaySubject<(_: ControlValueAccessor) => void>();

  constructor(
    public modalCtrl: ModalController,
    public translate: TranslateService,
    public alertCtrl: AlertController
  ) {}

  openInfo(){
    this.modalCtrl.create(InfoModalPage, {
      title: this.infoTitle,
      text: this.infoText
    }).present();
  }

  isValid(){
    return (this.form.get(this.formControlName).valid);
  }

  onChange(event){
    let field = this.form.get(this.formControlName);
    if(event == '-'){
      this.alertCtrl.create({
        title: this.translate.instant('Anders...'),
        enableBackdropDismiss: false,
        inputs: [
          {
            name: 'input_value',
            placeholder: this.translate.instant('Vul in')
          }
        ],
        buttons: [
          {
            text: this.translate.instant('Annuleren'),
            role: 'cancel',
            handler: () => {
              field.patchValue('');
              this.select.value = '';
            }
          },
          {
            text: this.translate.instant('OK'),
            handler: (data) => {
              if (data.input_value) {
                if(this.options.indexOf(data.input_value) === -1){
                  this.options.push(data.input_value);
                }
                field.patchValue(data.input_value);
                this.select.value = data.input_value;
                //this.select.selectedText = data.input_value;
              } else {
                return false;
              }
            }
          }
        ]
      }).present();
    } else {
      this.select.value = event;
    }
    if(field.value != event){
      field.patchValue(event);
    }
    console.log(field.value);
  }

  ngOnInit() {
    let currentValue = this.form.get(this.formControlName).value;
    if(currentValue && this.options.indexOf(currentValue) === -1){
      this.options.push(currentValue);
    }
    this.select.value = currentValue;
  }

  ngAfterViewInit(): void {
    this.delegatedMethodCalls.subscribe(fn => fn(this.valueAccessor));
  }

  registerOnChange(fn: (_: any) => void): void {
    this.delegatedMethodCalls.next(valueAccessor => valueAccessor.registerOnChange(fn));
  }
  registerOnTouched(fn: () => void): void {
    this.delegatedMethodCalls.next(valueAccessor => valueAccessor.registerOnTouched(fn));
  }

  setDisabledState(isDisabled: boolean): void {
    this.delegatedMethodCalls.next(valueAccessor => valueAccessor.setDisabledState(isDisabled));
  }

  writeValue(obj: any): void {
    this.delegatedMethodCalls.next(valueAccessor => valueAccessor.writeValue(obj));
    if(this.select){
      this.select.value = obj;
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/item-select-other/item-select-other.ts